import { render, staticRenderFns } from "./item-requests.vue?vue&type=template&id=6563e7a2&"
import script from "./item-requests.vue?vue&type=script&lang=js&"
export * from "./item-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports